import type { AuthService } from "../../auth/services/auth.service";
import type { HttpAdapter } from "../../core/adapters/axios.adapter";
import type { Eligibility } from "../models/newsletter.models";

export class OldNewsletterService {

    constructor(private oldNewsletterFormAdapter: HttpAdapter, private authService: AuthService = window.tbwServices.authService) {
    }

    init() {
        console.log("NewsletterService initialized with jwt");
    }

    async checkEligibility(nlId: string): Promise<Eligibility> {
        try {
            if (!this.authService.isAuthenticated || !nlId) { throw new Error("Token or nlId not provided") }
            const response = await this.oldNewsletterFormAdapter.get(`/${nlId}`)

            return response.data;
        }
        catch (error) {
            throw error
        }
    }

    async subscribe(email: string, nlId: string): Promise<any> {
        try {
            if (!nlId) { throw new Error("NlId not provided") }
            if (!this.authService.isAuthenticated && !email) { throw new Error("Either token or email must be provided") }

            const data = JSON.stringify(email ? { email } : {})

            const response = await this.oldNewsletterFormAdapter.post(`/${nlId}`, data)
            return response.data;
        }
        catch (error) {
            throw error
        }
    }

    async unsubscribe(nlId: string) {
        try {
            if (!this.authService.isAuthenticated || !nlId) { throw new Error("Token or nlId not provided") }

            const response = await this.oldNewsletterFormAdapter.delete(`${nlId}`);
            return response.data;
        }
        catch (error) {
            throw error
        }
    }
}
